import { TState, TActionTypes, ActionTypes } from './types'

const INITIAL_STATE: TState = {
  spinner: {
    remove: false,
    show: true,
  },
  alert: {
    show: false,
    status: 0,
    message: '',
  },
}

/**
 * @function reducer
 * @param state
 * @param action
 */
export default function reducer(
  state = INITIAL_STATE,
  action: TActionTypes,
): TState {
  switch (action.type) {
    case ActionTypes.CHANGE_SPINNER:
      return { ...state, spinner: { ...state.spinner, ...action.payload } }

    case ActionTypes.CHANGE_ALERT:
      return { ...state, alert: { ...state.alert, ...action.payload } }

    default:
      return state
  }
}
